import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FunctionalLoader, Page } from 'seagull';
import ImportWizard from "../../components/ImportWizard/ImportWizard";
import { routes } from "../../constants";
import { useStoreActions } from "../../contexts";
import { useContacts } from "../../hooks/reactQuery/queries/useContacts";
import { useSetDocumentTitle } from "../../hooks/useSetDocumentTitle";
import { ErrorResponse } from "../../infra/ErrorResponse";
import { NewContactModel } from "../../models/ContactModel";
import { parseAndValidateContactsCsv } from "./parseAndValidateContactsCsv";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const csvTemplateUrl = 'https://storage.googleapis.com/anchor-statics/Anchor_Import_Contacts-2023-09-20.zip';
const title = 'Import Contacts';
const entityName = 'contacts';
export default function ImportContacts() {
  const {
    contacts,
    isLoading,
    error
  } = useContacts({
    refreshOnMount: true
  });
  const {
    logBI,
    api
  } = useStoreActions();
  const history = useHistory();
  const [currentSaveData, setCurrentSaveData] = useState();
  const gotoContacts = () => history.push(routes.contacts);
  useSetDocumentTitle(title);
  if (error) throw error;
  return /*#__PURE__*/_jsxs(Page, {
    header: title,
    subheader: "Import your existing contacts in bulk in a few simple steps.",
    "data-testid": "import-contacts",
    loading: isLoading,
    onClickBack: gotoContacts,
    children: [/*#__PURE__*/_jsx(FunctionalLoader, {
      show: !contacts
    }), /*#__PURE__*/_jsx(ImportWizard, {
      entityName: entityName,
      saveEntityName: entityName,
      importBtnText: "Import contacts",
      csvTemplateUrl: csvTemplateUrl,
      currentSaveData: currentSaveData,
      testid: "import-contacts",
      parseAndValidateCsv: csvData => parseAndValidateContactsCsv(csvData, contacts),
      onStartSave: () => {
        setCurrentSaveData(undefined);
        return Promise.resolve();
      },
      saveItem: (contact, idx, contacts) => api.contact.create(NewContactModel.make(contact)).catch(err => {
        const msg = new ErrorResponse(err).saveContactErrorText();
        setCurrentSaveData({
          entity: entityName,
          saved: idx,
          total: contacts.length,
          errorMsg: msg
        });
        throw err;
      }),
      onEvent: (name, payload) => {
        if (name === 'csvTemplateDownload') {
          logBI(12150);
        } else if (name === 'csvUploaded') {
          logBI(12151, {
            numErrors: payload.badCsv ? 1 : payload.errors.length,
            numRows: payload.items.length
          });
        } else if (name === 'redirectToItems') {
          gotoContacts();
        } else if (name === 'afterSaveFailure') {
          logBI(12152, {
            success: false
          });
        } else if (name === 'afterSaveSuccess') {
          logBI(12152, {
            success: true
          });
        }
      }
    })]
  });
}